import { render, staticRenderFns } from "./AddAgent.vue?vue&type=template&id=2524e96e&scoped=true"
import script from "./AddAgent.vue?vue&type=script&lang=js"
export * from "./AddAgent.vue?vue&type=script&lang=js"
import style0 from "./AddAgent.vue?vue&type=style&index=0&id=2524e96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2524e96e",
  null
  
)

export default component.exports